// ACQUENZA scroll-reveal: tiny, dependency-free IntersectionObserver helper.
// Applies the .acq-in-view class to any .acq-reveal element once it enters
// the viewport. Never applied to price/add-to-cart controls (see markup).
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.acq-reveal').forEach(function (el) {
      el.classList.add('acq-in-view');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('acq-in-view');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observe(root) {
    (root || document).querySelectorAll('.acq-reveal:not(.acq-in-view)').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe(document);
    });
  } else {
    observe(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
